import Cookies from 'js-cookie'
import psl from "psl";

const TokenKey = 'Token';
const RedirectUrlKey = 'AFC-RedirectUrl';

const getTokenKey = () => {
  const prefix = localStorage.getItem('prefix')
  return prefix ? prefix + '_' + TokenKey : TokenKey
}

let domain = psl.get(window.location.hostname);
domain = domain && `.${domain}`;

export function getToken() {
  return Cookies.get(getTokenKey());
}

export function setToken(token) {
  let options = {
    expires: new Date(new Date().getTime() + 23 * 60 * 60 * 1000)
  };
  if (domain) {
    options.domain = domain;
  }
  return Cookies.set(getTokenKey(), token, options)
}

export function removeToken() {
  let options = {};
  if (domain) {
    options.domain = domain;
  }
  return Cookies.remove(getTokenKey(), options)
}

export function setRedirectUrl(redirectUrl) {
  return Cookies.set(RedirectUrlKey, redirectUrl)
}

export function getRedirectUrl() {
  return Cookies.get(RedirectUrlKey)
}

export function removeRedirectUrl() {
  return Cookies.remove(RedirectUrlKey)
}

export function setCallbackUrl(callbackUrl) {
  let options = {
    expires: new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000),
  }
  if (domain) {
    options.domain = domain
  }
  Cookies.set('callbackUrl', callbackUrl, options)
}